import { useMemo } from 'react';

interface UseFilteredDataProps<T> {
    data: T[] | undefined;
    searchQuery: string;
    searchFields?: (keyof T)[];
}

const useFilteredData = <T>({data, searchQuery, searchFields}: UseFilteredDataProps<T>) => useMemo(() => {
    if (!data || !searchQuery || !searchFields) return data;

    return data.filter(item =>
        searchFields?.some(field => {
            const value = item[field];
            return value &&
                String(value).toLowerCase().includes(searchQuery.toLowerCase());
        }) ?? true);
}, [data, searchQuery, searchFields]);

export default useFilteredData;